import { FileError, FileRejection } from "react-dropzone";
import { useTranslation } from "react-i18next";

type UploadErrorsProps = {
  fileRejections: FileRejection[];
  errorMessages: { [errorCode: string]: string };
};
/**
 *
 * These are the different error codes that you should provide a messages for them
 * "file-invalid-type", "file-too-large", "file-too-small", "too-many-files"
 *
 */
export default function UploadErrors({
  fileRejections,
  errorMessages,
}: UploadErrorsProps) {
  const ErrorItem = ({ e }: { e: FileError }) => {
    if (!errorMessages[e.code]) return null;

    return (
      <li
        data-cy="error-file"
        key={e.code}
        className="mt-2 text-sm text-red-600"
      >
        {errorMessages[e.code]}
      </li>
    );
  };

  return (
    <ul>
      {fileRejections.map(({ file, errors }, idx) => (
        <li key={`${idx}-${file.name}`}>
          <ul>
            {errors.map((e) => (
              <ErrorItem e={e} />
            ))}
          </ul>
        </li>
      ))}
    </ul>
  );
}
